import Tool, { type ToolArgsWithController } from '../../../tools/Tool';
import { Transforms } from 'slate';
import type {
  SharedSnippetElement,
  SharedSnippetInlineElement,
} from '../../../types/aha-editor';

class ToolAddSnippet extends Tool {
  static toolName = 'Snippet';
  static iconClass = 'aha-icon aha-icon-shared-snippet';

  static available({ controller }: ToolArgsWithController): boolean {
    const provider = controller.ahaEditor.getProvider('sharedSnippet');
    return Boolean(provider && provider.featureEnabled());
  }

  static async action({ editor, controller }: ToolArgsWithController) {
    const provider = controller.ahaEditor.getProvider('sharedSnippet');
    if (!provider) return;

    const snippetReference = await provider.onAddSharedSnippet();
    if (!snippetReference) return;

    const snippet: SharedSnippetElement | SharedSnippetInlineElement = {
      type:
        snippetReference.mode === 'inline'
          ? 'shared-snippet-inline'
          : 'shared-snippet',
      sharedSnippet_token: snippetReference.token,
      children: [{ text: '' }],
    };

    Transforms.insertNodes(editor, snippet);
  }
}

export default ToolAddSnippet;
